import { addDays, differenceInDays, format, isSameDay } from "date-fns";
import { ru } from "date-fns/locale";

export interface RegistrationBonus {
  amount: number;
  activates_at: number;
  expires_at: number;
}

const dayForms: Record<string, string> = { one: "день", few: "дня", many: "дней", other: "дня" };
const dayRules = new Intl.PluralRules("ru");

export const pluralDays = (n: number): string => `${n} ${dayForms[dayRules.select(n)]}`;

const humanMoment = (ms: number, now: Date): string => {
  const date = new Date(ms);
  const time = format(date, "HH:mm");
  if (isSameDay(date, now)) return `сегодня в ${time}`;
  if (isSameDay(date, addDays(now, 1))) return `завтра в ${time}`;
  return format(date, "d MMMM 'в' HH:mm", { locale: ru });
};

const humanDate = (ms: number, now: Date): string => {
  const date = new Date(ms);
  const pattern = date.getFullYear() === now.getFullYear() ? "d MMMM" : "d MMMM yyyy";
  return format(date, pattern, { locale: ru });
};

const expiryLine = (bonus: RegistrationBonus, now: Date): string => {
  if (bonus.expires_at <= 0) return "Без срока сгорания";
  const days = differenceInDays(bonus.expires_at, bonus.activates_at || now.getTime());
  const until = humanDate(bonus.expires_at, now);
  return days > 0 ? `Действуют ${pluralDays(days)} — до ${until}` : `Действуют до ${until}`;
};

export const registrationBonusText = (bonus: RegistrationBonus, now = new Date()) => ({
  title: `Вам начислено ${bonus.amount.toLocaleString("ru-RU")} бонусов`,
  lines: [
    bonus.activates_at > 0
      ? `Станут доступны ${humanMoment(bonus.activates_at, now)} — тогда же появятся на балансе карты`
      : "Уже на вашей карте — можно тратить",
    expiryLine(bonus, now),
  ],
});

export const parseRegistrationBonus = (raw: unknown): RegistrationBonus | null => {
  if (!raw) return null;
  try {
    const value = typeof raw === "string" ? JSON.parse(raw) : raw;
    return value && value.amount > 0 ? (value as RegistrationBonus) : null;
  } catch (e) {
    return null;
  }
};
